var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconCarbonTracker64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_19515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.4239 8.50293C35.5358 8.50293 32.111 10.4585 30.1067 13.4263C28.7671 12.7491 27.2488 12.3669 25.64 12.3669C20.2276 12.3669 15.84 16.6919 15.84 22.0269C15.84 22.1238 15.8414 22.2203 15.8443 22.3165C15.3777 22.2095 14.8912 22.1529 14.3913 22.1529C10.8615 22.1529 8 24.9735 8 28.4529C8 31.9323 10.8615 34.7529 14.3913 34.7529C14.4085 34.7529 14.4257 34.7529 14.4429 34.7527L49.5435 34.7529L49.5438 34.7357C53.7076 34.4654 57 31.0507 57 26.8779C57 23.0656 54.2518 19.8861 50.6017 19.1591C50.4058 13.2415 45.4762 8.50293 39.4239 8.50293Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3405 48.8974C39.8572 48.8981 37.6678 48.9048 37.4097 48.8973C33.5369 48.784 30.75 44.3467 30.75 39.0808C30.75 31.0875 34.8615 24.415 38.7433 22.85C39.2631 22.6226 39.8002 22.5029 40.3417 22.5029L40.375 22.5035L40.4083 22.5029C40.9498 22.5029 41.4869 22.6226 42.0068 22.8503C45.8885 24.415 50 31.0875 50 39.0808C50 44.3467 47.2131 48.784 43.3403 48.8973C43.0822 48.9048 40.8928 48.8981 40.4095 48.8974H40.3405Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5532 36.978V56.3365",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5531 45.7334L36.6318 41.5098",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_19515"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconCarbonTracker64);
export default __webpack_public_path__ + "static/media/pictogramBeaconCarbonTracker64.979b4edc0fae515f899402f8df3fd73f.svg";
export { ForwardRef as ReactComponent };